import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { translateFormFieldPlaceholder } from '../../../../../../helpers/collaborativeIndexations'
import { sanitizeYear } from '../../../../../../helpers/date/year'
import classNames from 'classnames'

class Year extends Component
{
    static propTypes = {
        t: PropTypes.func.isRequired,
        updateFieldValue: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
        isInvalidField: PropTypes.func.isRequired,
        resetInvalidField: PropTypes.func.isRequired,
        fieldName: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        hasFocus: PropTypes.bool,
    }

    constructor(props)
    {
        super(props)

        this.handleOnChange = this.handleOnChange.bind(this)
        this.mainField = React.createRef()
    }

    componentDidMount()
    {
        if(this.props.hasFocus === true)
        {
            this.mainField.current.focus()
        }
    }

    handleOnChange(event)
    {
        const { fieldName, updateFieldValue, resetInvalidField } = this.props

        resetInvalidField(fieldName)
        updateFieldValue(fieldName, sanitizeYear(event.target.value))
    }

    render()
    {
        const { t, fields, fieldName, label, isInvalidField } = this.props

        return (
            <div className={'form-group year'}>
                <label>{label}</label>
                <input
                    ref={this.mainField}
                    type={'number'}
                    className={classNames({'error': isInvalidField(fieldName)})}
                    placeholder={translateFormFieldPlaceholder(t, 'year')}
                    onChange={this.handleOnChange}
                    value={fields[fieldName] !== null ? fields[fieldName] : ''}
                />
            </div>
        )
    }
}

export default withTranslation()(Year)
